const pageNotFoundStrings = {
    seoTitle: "La Estrellita | Página No Encontrada",
    pageDoesntExist: "Esta página no existe.",
    goBack: "Por favor revisa la URL que has ingresado o haz clic en el botón abajo para regresar a la página de inicio.",
    homeButton: "Regresar al Inicio",
};

export default pageNotFoundStrings;